<template>
  <div class="s-professionalInfoConsultationAdvisoryDetails-container">
    <topNav></topNav>
    <div class="s-information-top">
      <div class="banner w1300 marginAuto"></div>
    </div>
    <div class="content w1300 marginAuto">

      <div class="crumbs">
        <img src="../assets/image/index/home.png" class="img" alt />
        <span @click="crumbsGoRoute('index')" class="go">首页&gt;</span>
        <span @click="crumbsGoRoute('professionalInfoConsultation')" class="go"
          >专业信息咨询&gt;</span
        >
        <span>专业技术咨询详情</span>
      </div>
      <div class="expert-introduction-wrap">
        <div class="expert-baseinfo-wrap">
          <div class="expert-img">
            <img :src="imgURL + '/' + expertInfo.headImg" alt />
          </div>
          <div class="baseinfo-1">
            <div class="base-info-title">基本信息</div>
            <div>
              <span class="span-title">姓名：</span
              >{{ expertInfo.expertName || "--" }}
            </div>
            <div>
              <span class="span-title">性别：</span>{{ expertInfo.sex || "--" }}
            </div>
            <div>
              <span class="span-title">研究方向：</span
              >{{ expertInfo.researchArea || "--" }}
            </div>
          </div>
          <div class="baseinfo-2">
            <div>
              <span class="span-title">职称：</span
              >{{ expertInfo.title || "--" }}
            </div>
            <div>
              <span class="span-title">单位：</span
              >{{ expertInfo.workplace || "--" }}
            </div>
            <div>
              <span class="span-title">邮箱：</span
              >{{ expertInfo.email || "--" }}
            </div>
          </div>
        </div>
        <div class="expert-baseinfo-desc">
          <div>
            {{ expertInfo.expertIntroduction || "暂无简介！" }}
            <!-- 取得国家科技进步二等奖1项（参加人），农业部科技进步奖二等奖1项（第11完成人）和三等奖1项（第5完成人），中国农业科学院科技进步二等奖1项（第4完成人），取得专利权3项（第1完成人）； 主持国家科技支撑计划“茶产业升级关键技术研究与示范”和浙江省重大科技成果转化工程《十县五十万亩茶产业升级转化工程》等科技项目15项；制定《无公害食品茶叶》等国家行业标准12项,主编《茶叶、可可、咖啡质量检验》等著作4部，主编中央广播电视大学教材《茶叶审评与检验技术》和全国职业教育教材《茶叶审评与检验技术》2部，副主编《农产品质量安全全程控制技术规范（GAP）》等著作4部，发表《国内外茶叶标准对比分析研究》等论文60余篇，其中SCI论文17篇。-->
          </div>
        </div>
      </div>
      <div class="online-message-wrap">
        <div class="message-title">在线留言</div>
        <el-form
          ref="form"
          :model="form"
          label-width="140px"
          :rules="uploadformrules"
        >
          <el-form-item label="问题名称：" class="message-form-item">
            <el-input v-model="form.name" class="input-width"></el-input>
          </el-form-item>

          <el-form-item
            label="上传图片或视频："
            class="message-form-item"
            style="height: 150px"
            prop="fileList"
          >
            <!-- https://jsonplaceholder.typicode.com/posts/ -->
            <!-- list-type="picture-card" -->
            <el-upload
              ref="uploadFile"
              name="file"
              action="#"
              class="imgVideoUpLoad"
              accept=".png,.jpg,.jpeg,.mp4"
              :show-file-list="false"
              :on-change="fileChange"
              :on-exceed="uploadExceed"
              :http-request="upload"
            >
              <img
                v-if="imgUrl != '' && imgVedioType == 'image'"
                :src="imgUrl"
                alt=""
                style="width: 148px; height: 148px"
              />
              <video
                style="width: 148px; height: 148px"
                :src="imgUrl"
                v-if="imgUrl != '' && imgVedioType == 'video'"
                controls="controls"
              >
                您的浏览器不支持视频播放
              </video>
              <i class="el-icon-plus" v-if="imgUrl == ''"></i>
            </el-upload>
          </el-form-item>

          <div style="clear: both"></div>
          <el-form-item
            label="问题类型："
            style="margin-top: -100px; width: 35%; float: left"
          >
            <el-select
              v-model="form.type"
              placeholder="请选择问题类型"
              class="input-width"
            >
              <el-option
                :label="itm.codeName"
                :value="itm.codeValue"
                v-for="(itm, ind) in typeList"
                :key="ind"
              ></el-option>
            </el-select>
          </el-form-item>
          <div style="clear: both"></div>
          <el-form-item label="问题描述：" style="margin-top: 20px">
            <el-input type="textarea" v-model="form.desc"></el-input>
          </el-form-item>
          <el-form-item>
            <div class="submitBtn marginAuto" @click="submitQuestions('form')">
              提交问题
            </div>
          </el-form-item>
        </el-form>
      </div>
      <div class="question-list-wrap">
        <div class="message-title">问题列表</div>
        <div class="question-list">
          <ul>
            <li
              v-for="(item, index) in questionListData"
              :key="index"
              class="question-item"
              @click="openAnswerQuestionsDialog(item)"
            >
              <div>
                <span class="disc"></span>
                {{ item.qtitle }}
              </div>
              <div class="date">{{ item.createTime }}</div>
            </li>
          </ul>
        </div>
      </div>
      <div class="s-transaction-pagination">
        <el-pagination
          class="tab_pagination"
          background
          :page-size="pageSize"
          :current-page="currentPage"
          layout="prev, pager, next"
          @current-change="currentChange"
          :total="total"
        ></el-pagination>
      </div>
    </div>
    <footer-nav></footer-nav>
    <el-dialog
      title
      :visible.sync="answerQuestionsDialog"
      width="80%"
      :before-close="handleAnswerQuestionsClose"
      :close-on-click-modal="false"
      class="answerQuestionsDialog"
    >
      <div class="answer-questions-body">
        <div class="answer-questions-desc">
          <div class="questions-img">
            <img
              :src="qDetail.qimg"
              v-if="qDetail.imgType == 'image'"
              class="img"
              alt
            />
            <video
              :src="qDetail.qimg"
              class="img"
              v-if="qDetail.imgType == 'video'"
              controls
            ></video>
          </div>
          <div>
            <div class="questions-title">
              {{ qDetail.qtitle ? qDetail.qtitle : "--" }}
            </div>
            <div class="questions-type">
              <div>
                <span class="span-title">问题类型：</span
                >{{ qDetail.qtypeValue ? qDetail.qtypeValue : "--" }}
              </div>
              <div>
                <span class="span-title">提问人：</span
                >{{ qDetail.createUserName ? qDetail.createUserName : "--" }}
              </div>
              <div>
                <span class="span-title">时间：</span
                >{{ qDetail.createTime ? qDetail.createTime : "--" }}
              </div>
            </div>
            <div class="questions-desc">
              <div class="questions-desc-title">问题描述：</div>
              {{ qDetail.qinfo ? qDetail.qinfo : "--" }}
              <!-- 需要种植一批金银眉红茶，最佳的海拔是多少z/需要种植一批金银眉红茶，最佳的海拔是多少?需要种植一批金银眉红茶，
              最佳的海拔是多少?需要种植一批金银眉红茶，最佳的海拔是多少需要种植一批金银眉红茶，最佳的海拔是多少z/需要种植一批金银眉红茶，
              最佳的海拔是多少?需要种植一批金银眉红茶，最佳的海拔是多少?需要种植一批金银眉红茶，最佳的海拔是多少 -->
            </div>
          </div>
        </div>
        <div class="experts-reply-wrap">
          <div class="experts-reply-title" v-if="qDetail.fsQaInfoList != null">
            专家回复：
          </div>
          <div
            class="experts-reply"
            v-for="(itemChild, idnn) in qDetail.fsQaInfoList"
            :key="idnn"
          >
            <div class="answerTime">{{ itemChild.createTime || "--" }}</div>
            <span>{{ itemChild.createUserName || "--" }}</span
            >：<span>{{ itemChild.content || "--" }}</span>

            <!-- 需要种植一批金银眉红茶，最佳的海拔是多少z/需要种植一批金银眉红茶，最佳的海拔是多少?需要种植一批金银眉红茶
            ，最佳的海拔是多少?需要种植一批金银眉红茶，最佳的海拔是多少需要种植一批金银眉红茶，最佳的海拔是多少z/需要种植一批金银眉红茶，
            最佳的海拔是多少?需要种植一批金银眉红茶，最佳的海拔是多少?需要种植一批金银眉红茶，最佳的海拔是多少 -->
          </div>
          <div
            class="experts-reply experts-reply-noData"
            style="
              height: 170px;
              text-align: center;
              line-height: 170px;
              color: #666;
              font-size: 16px;
            "
            v-if="qDetail.fsQaInfoList == null"
          >
            无数据!
          </div>
          <!-- <el-input type="textarea" :rows="9" placeholder="请输入回复内容" v-model="textarea"></el-input> -->
        </div>
        <div class="addAsk">
          <span class="name">追问</span>
          <el-input v-model="askVal" placeholder="请输入追问内容"></el-input>
        </div>
        <div class="experts-reply-btn" @click="expertAnsweringQuestion">
          提交
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import topNav from "../components/topNav.vue";
import footerNav from "../components/footerNav.vue";
import {
  expertDetail,
  getQuestionListPage,
  questionDetail,
  expertAnsweringQuestion,
  selectListByType,
  upload,
  submitQuestions,
} from "../utils/api/specialistPerson";
export default {
  name: "professionalInfoConsultationAdvisoryDetails",
  data() {
    return {
      answerQuestionsDialog: false,
      textarea: "",
      form: {
        name: "",
        desc: "",
        type: "",
        imgUrl: "",
        fileList: [],
      },
      uploadformrules: {
        fileList: [
          { required: true, message: "请选择视频", trigger: "change" },
        ],
      },
      imgUrl: "",
      imgVedioType: null,
      typeList: [],
      questionListData: [
        // { title: "茶乡福安打造三茶融合示范区", date: "2022/5/22" },
        // { title: "茶乡福安打造三茶融合示范区", date: "2022/5/22" },
        // { title: "茶乡福安打造三茶融合示范区", date: "2022/5/22" },
        // { title: "茶乡福安打造三茶融合示范区", date: "2022/5/22" }
      ],
      qDetail: {},
      expertId: "",
      expertInfo: {},
      currentPage: 1, // 页码
      pageSize: 5, // 每页显示数量
      total: 0, // 总数,
      askVal: "",
      questionDetailId: "",
    };
  },
  components: { topNav, footerNav },
  mounted() {
    if (this.$route.query.id) {
      this.expertId = this.$route.query.id;
      this.expertDetail();
      this.getQuestionListPage();
      this.selectListByType();
    }
  },
  methods: {
    fileChange(file, fileList) {
      const isImage =
        file.raw.type == "image/png" ||
        file.raw.type == "image/jpg" ||
        file.raw.type == "image/jpeg";
      const isLt50M = file.raw.size / 1024 / 1024 < 50;
      const isMp4 = file.raw.type == "video/mp4";
      this.imgVedioType = file.raw.type.split("/")[0];

      if (fileList.length > 1) {
        //始终保证只有一张
        (this.form.fileList = []), (this.imgUrl = "");
        this.$refs.uploadFile.clearFiles();
      }
      if (this.imgVedioType == "image") {
        if (!isImage) {
          return this.$message.error("上传只能是png,jpg,jpeg格式!");
        }
        if (!isLt50M) {
          this.$message.error("图片大小不能超过 50MB!");
          return false;
        }
        if (fileList.length > 1) {
          //始终保证只有一张
          (this.form.fileList = []), (this.imgUrl = "");
        }
        this.imgUrl = URL.createObjectURL(file.raw);
        this.form.fileList = file;
      } else if (this.imgVedioType == "video") {
        if (!isMp4) {
          this.$refs.uploadFile.clearFiles();
          return this.$message.error("上传视频只能是mp4格式!");
        }
        if (!isLt50M) {
          this.$refs.uploadFile.clearFiles();
          this.$message.error("视频大小不能超过 50MB!");
          return false;
        }
        this.imgUrl = URL.createObjectURL(file.raw);
        this.form.fileList = file;
      }
    },
    //自定义图片上传
    async upload(file) {
      let datafile = new FormData();
      let params = {
        folder: "question",
      };
      datafile.append("file", file.file);
      let res = await upload(datafile, params);

      this.form.imgUrl = res.data;
      console.log(res.data, "上传成功！3323");
    },
    uploadExceed() {
      this.$message.error("一次只能上传一个文件！");
    },
    async submitQuestions(formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          if (JSON.parse(this.$store.state.isLogin)) {
            if (this.form.name == "") {
              return this.$message({
                type: "warning",
                message: "问题名称不能为空!",
              });
            }
            if (this.form.type == "") {
              return this.$message({
                type: "warning",
                message: "请选择问题类型!",
              });
            }
            if (this.form.desc == "") {
              return this.$message({
                type: "warning",
                message: "请填写问题描述!",
              });
            }
            let data = {
              qimg: this.form.imgUrl,
              qtitle: this.form.name,
              qtype: this.form.type,
              qinfo: this.form.desc,
              aexpertId: this.expertId,
            };
            let res = await submitQuestions(data);
            if (res.data.code == 0) {
              this.$message({
                type: "success",
                message: "提交成功!",
              });
              this.form = {
                name: "",
                desc: "",
                type: "",
                imgUrl: "",
                fileList: [],
              };
              this.imgUrl = "";
              this.imgVedioType = null;
              this.currentPage = 1;
              this.getQuestionListPage();
            } else if (res.code === -1) {
              this.$message({
                type: "warning",
                message: res.msg,
              });
              return false;
            }
          } else {
            return this.$message({
              type: "warning",
              message: "请先登录!",
            });
          }
        } else {
          return false;
        }
      });
    },
    openAnswerQuestionsDialog(item) {
      this.answerQuestionsDialog = true;
      this.questionDetailId = item.id;
      this.questionDetail();
    },
    handleAnswerQuestionsClose() {
      this.answerQuestionsDialog = false;
    },
    crumbsGoRoute(path) {
      this.$router.push({ path });
    },
    //专家详情
    async expertDetail() {
      let params = {
        id: this.expertId,
      };
      let res = await expertDetail(params);
      if (res.data.code == 0) {
        this.expertInfo = res.data.data;
      }
    },
    //问题列表
    async getQuestionListPage() {
      let params = {
        currentPage: this.currentPage,
        pageSize: this.pageSize,
      };
      let res = await getQuestionListPage(params);
      if (res.data.code == 0) {
        this.questionListData = res.data.data.records;
        this.total = res.data.data.total;
        console.log(res.data.data.records);
      }
    },
    currentChange(value) {
      this.currentPage = value;
      this.getQuestionListPage();
    },
    //更改pageSize
    pageSizeChange(value) {
      this.pageSize = value;
      this.getQuestionListPage();
    },
    //问题详情
    async questionDetail() {
      let params = {
        id: this.questionDetailId,
      };
      let res = await questionDetail(params);
      if (res.data.code == 0) {
        this.qDetail = {};
        this.qDetail = res.data.data;
        console.log("this.qDetail", this.qDetail);
        if (this.qDetail.qimg.indexOf("http:") == -1) {
          this.qDetail.qimg = this.detailBaseImgUrl + this.qDetail.qimg;
        }
        if (
          this.qDetail.qimg.split(".")[
            this.qDetail.qimg.split(".").length - 1
          ] == "mp4"
        ) {
          this.qDetail.imgType = "video";
        } else {
          this.qDetail.imgType = "image";
        }
      }
    },
    //追问
    async expertAnsweringQuestion() {
      if (JSON.parse(this.$store.state.isLogin)) {
        if (this.askVal == "") {
          return this.$message({
            type: "warning",
            message: "追问内容不能为空！",
          });
        }
        let data = {
          qaId: this.qDetail.id,
          content: this.askVal,
          createUserId: this.qDetail.createUserId,
          createUserName: this.qDetail.createUserName,
        };
        let res = await expertAnsweringQuestion(data);
        if (res.data.code == 0) {
          this.$message({
            type: "success",
            message: "追问提交成功！",
          });
          this.askVal = "";
          this.questionDetail();
          this.getQuestionListPage();
        }
      } else {
        return this.$message({
          type: "warning",
          message: "请先登录！",
        });
      }
    },
    //问题下拉列表
    async selectListByType() {
      let params = {
        codeType: "question_type",
      };
      let res = await selectListByType(params);
      if (res.data.code == 0) {
        this.typeList = res.data.data;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../utils/css/common.scss";
@import "../utils/css/professionalInfoConsultationAdvisoryDetails.scss";

</style>
<style lang="scss">
.answerQuestionsDialog {
  .el-dialog {
    background-color: #f8f8f8;
  }
  .experts-reply-wrap {
    .el-textarea__inner {
      border: none;
    }
  }
}
</style>
<style lang="scss">
.s-professionalInfoConsultationAdvisoryDetails-container {
  .tab_pagination {
    margin: 35px 0 35px;
  }
  .el-pagination {
    text-align: right;
  }
  .el-pagination.is-background .el-pager li:not(.disabled).active {
    background-color: #00b237;
    color: #fff;
  }
  .imgVideoUpLoad {
    .el-upload {
      background-color: #fbfdff;
      border: 1px dashed #c0ccda;
      border-radius: 6px;
      box-sizing: border-box;
      width: 148px;
      height: 148px;
      line-height: 146px;
      vertical-align: top;
    }
    .el-icon-plus {
      font-size: 28px;
      color: #ccc;
    }
  }
}
</style>
